import React, { useState } from 'react';
import {
  KTSVG,
  LoadingGrid,
  Pagination,
  formatPrice,
} from '../../../../../rbts/helpers';
import { DetailConciliationModal } from '../../../conciliation/_modals/DetailConciliationModal';
import { PdfPreviewConciliationModal } from '../../../conciliation/_modals/PdfPreviewConciliationModal';
import { useGetReportConciliations } from '../hooks/ReporteConsilationHook';

type Props = {
  reloadGrid: number;
  strDate: string;
  idDia: number;
  idTipo: number;
};

const PAGE_SIZE = 10;

const ConciliationGrid: React.FC<Props> = ({
  reloadGrid,
  strDate,
  idDia,
  idTipo,
}) => {
  const { conciliationsList, loadingRequest } = useGetReportConciliations(idDia, idTipo);
  const [showModalDetail, setShowModalDetail] = useState<boolean>(false);
  const [conciliationId, setConciliationId] = useState<number>(0);
  const [showModalPdf, setShowModalPdf] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const totalPages = Math.ceil(conciliationsList.length / PAGE_SIZE);
  const paginated = conciliationsList.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  return (
    <>
      {loadingRequest ? (
        <LoadingGrid text="Cargando..." />
      ) : !idDia ? (
        <div className="text-center text-muted py-8 fs-6">
          Seleccione un día administrativo para ver las conciliaciones.
        </div>
      ) : conciliationsList.length === 0 ? (
        <div className="text-center text-muted py-8 fs-6">
          No se encontraron conciliaciones para el día seleccionado.
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-hover table-rounded table-striped border gy-4 gs-7">
              <thead>
                <tr className="fw-bolder fs-7 text-gray-800 border-bottom border-gray-200">
                  <th>Folio</th>
                  <th>Nombre del puesto</th>
                  <th>Proveedor</th>
                  <th className="text-end">Saldo</th>
                  <th className="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((row: any) => (
                  <tr key={row.id} className="align-middle">
                    <td className="fw-bold fs-7" style={{ color: '#1e3a5f' }}>
                      {row.folio ?? 'No registrado'}
                    </td>
                    <td className="fs-7">{row.punto_venta?.nombre ?? 'No registrado'}</td>
                    <td className="fs-7 text-muted">No registrado</td>
                    <td className="text-end fs-7 fw-semibold">
                      {row.monto ? (
                        <span style={{ color: '#1a7a4a' }}>
                          {formatPrice(row.total_a_pagar ?? 0, 'es-MX', 'MXN', 2, 2)}
                        </span>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </td>
                    <td className="text-center">
                      <a
                        className="btn btn-sm ms-2"
                        href="#/"
                        title="Descargar pdf"
                        onClick={() => {
                          setShowModalPdf(!showModalPdf);
                          setConciliationId(row.id);
                        }}
                      >
                        <KTSVG
                          path="/media/icons/duotune/files/fil029.svg"
                          className="svg-icon-1 svg-icon-primary"
                        />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          )}
        </>
      )}
      <DetailConciliationModal
        strDate={strDate}
        show={showModalDetail}
        concilation={conciliationId}
        handleClose={() => {
          setShowModalDetail(false);
          setConciliationId(0);
        }}
      />
      <PdfPreviewConciliationModal
        strDate={strDate}
        show={showModalPdf}
        concilation={conciliationId}
        handleClose={() => {
          setShowModalPdf(false);
          setConciliationId(0);
        }}
      />
    </>
  );
};

export { ConciliationGrid };
